"use strict";
//http://fusion.stolaf.edu/cfximage/docs/iptc_list.cfm
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldMap = {
    3: { name: "OBJECT_TYPE_REFERENCE" },
    4: { name: "OBJECT_ATTRIBUTE_REFERENCE" },
    5: { name: "OBJECT_NAME" },
    7: { name: "EDIT_STATUS" },
    8: { name: "EDITORIAL_UPDATE" },
    10: { name: "URGENCY" },
    12: { name: "SUBJECT_REFERENCE" },
    15: { name: "CATEGORY" },
    20: { name: "SUPPLEMENTAL_CATEGORIES", repeatable: true },
    22: { name: "FIXTURE_ID", repeatable: true },
    25: { name: "KEYWORDS", repeatable: true },
    26: { name: "CONTENT_LOCATION_CODE", repeatable: true },
    27: { name: "CONTENT_LOCATION_NAME", repeatable: true },
    30: { name: "RELEASE_DATE" },
    35: { name: "RELEASE_TIME" },
    37: { name: "EXPIRATION_DATE" },
    38: { name: "EXPIRATION_TIME" },
    40: { name: "SPECIAL_INSTRUCTIONS" },
    42: { name: "ACTION_ADVISED" },
    45: { name: "REFERENCE_SERVICE", repeatable: true },
    47: { name: "REFERENCE_DATE", repeatable: true },
    50: { name: "REFERENCE_NUMBER", repeatable: true },
    55: { name: "DATE_CREATED", format: "date" },
    60: { name: "TIME_CREATED", format: "time" },
    62: { name: "DIGITAL_DATE_CREATED", format: "date" },
    63: { name: "DIGITAL_TIME_CREATED", format: "time" },
    65: { name: "ORIGINATING_PROGRAM" },
    70: { name: "PROGRAM_VERSION" },
    75: { name: "OBJECT_CYCLE" },
    80: { name: "BY_LINE", repeatable: true },
    84: { name: "CAPTION" },
    85: { name: "BY_LINE_TITLE", repeatable: true },
    90: { name: "CITY" },
    92: { name: "SUB_LOCATION" },
    95: { name: "PROVINCE_OR_STATE" },
    100: { name: "COUNTRY_OR_PRIMARY_LOCATION_CODE" },
    101: { name: "COUNTRY_OR_PRIMARY_LOCATION_NAME" },
    103: { name: "ORIGINAL_TRANSMISSION_REFERENCE" },
    105: { name: "HEADLINE" },
    110: { name: "CREDIT" },
    115: { name: "SOURCE" },
    116: { name: "COPYRIGHT_NOTICE" },
    118: { name: "CONTACT" },
    120: { name: "CAPTION" },
    121: { name: "LOCAL_CAPTION" },
    122: { name: "CAPTION_WRITER", repeatable: true },
    125: { name: "RASTERIZED_CAPTION" },
    130: { name: "IMAGE_TYPE" },
    131: { name: "IMAGE_ORIENTATION" },
    135: { name: "LANGUAGE_IDENTIFIER" },
    150: { name: "AUDIO_TYPE" },
    151: { name: "AUDIO_SAMPLING_RATE" },
    152: { name: "AUDIO_SAMPLING_RESOLUTION" },
    153: { name: "AUDIO_DURATION" },
    154: { name: "AUDIO_OUTCUE" },
    184: { name: "JOB_ID" },
    185: { name: "MASTER_DOCUMENT_ID" },
    186: { name: "SHORT_DOCUMENT_ID" },
    187: { name: "UNIQUE_DOCUMENT_ID" },
    188: { name: "OWNER_ID" },
    200: { name: "OBJECT_PREVIEW_FILE_FORMAT" },
    201: { name: "OBJECT_PREVIEW_FILE_FORMAT_VERSION" },
    202: { name: "OBJECT_PREVIEW_DATA" }
};
//# sourceMappingURL=IptcFieldMap.js.map